import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { RemissionService, RemissionData, Remission, Defect, QualityCertificate } from '../../services/remission.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProductionOrderService, ProductionOrderId } from '../../services/production-order.service';
import { MaterializeAction, toast } from 'angular2-materialize';
import { Utils } from '../../util';
import { DefectService, DefectId } from '../../services/defect.service';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { CompanyService } from '../../services/company.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { EmployeeService } from '../../services/employee.service';

@Component({
  selector: 'app-certificate',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.css']
})
export class CertificateComponent implements OnInit, OnDestroy {

  remission: Remission;
  remissionId: string = '';
  remissionFolio: string = '';
  qualitys: QualityCertificate[] = [];
  qualityInspectorName: string = '';

  form: FormGroup;
  statusSelect: any[] = [];
  odpSectionSelect: any[] = [];
  lotIsComplete: boolean = false;
  AQLS: string[] = [];
  aqls: any = {};
  defectsInit: any;
  inspectionType: any[] = [];
  inspectionLevels: string[] = [
    'S-1',
    'S-2',
    'S-3',
    'S-4',
    'I',
    'II',
    'III',
  ];
  
  company: any = {};
  isoDescription: any = {};
  odp: ProductionOrderId;

  sub: Subscription;

  constructor(
    private service: RemissionService,
    private data: RemissionData,
    private productionOrderService: ProductionOrderService,
    private defectService: DefectService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private userService: UserService,
    private authService: AuthService,
    private companyService: CompanyService,
    private settings: CatalogsSettingsService,
    private employeeService: EmployeeService
  ) {
    this.remissionId = activatedRoute.snapshot.paramMap.get('id');

    let companySub = this.companyService.getCompany().subscribe(company => {
      companySub.unsubscribe();
      this.company = company;
    });

    let setSub = this.settings.getPayrollSettings('1').subscribe(({isoDescriptions: {Rem, Etiq, CrtCal}, specialRoles}) => {
      setSub.unsubscribe();
      [ this.isoDescription.rem, this.isoDescription.etiq, this.isoDescription.crtcal ] = [Rem, Etiq, CrtCal];
      let {qualityInspector=''} = specialRoles, sub;
      if(qualityInspector) sub = employeeService.getEmployee(qualityInspector).subscribe(({name, lastName}) => {
        sub.unsubscribe();
        this.qualityInspectorName = `${name} ${lastName}`;
      });
    });

    this.statusSelect = Object.keys(data.certificateStatus).map(key => ({value: key, ...data.certificateStatus[key]}) );
    this.inspectionType = Object.keys(data.inspectionTypes).map(key => ({value: key, ...data.inspectionTypes[key]}) );
  }

  ngOnInit() {
    this.createForm();
    this.sub = this.service.getRemission(this.remissionId).subscribe(([remission]:Remission[]) => {
      this.remission = remission;

      let { qualityCertificate={}as QualityCertificate, productionOrder, folio, customerRef, qualityHistory=[] } = remission;
      this.form.patchValue(qualityCertificate);
      this.lotIsComplete = !!qualityCertificate.lotIsComplete
      this.defects = qualityCertificate.defects || [];
      this.remissionFolio = `${folio}`;
      this.qualitys = [...qualityHistory];
      this.qualitys.map(q => {
        let userSub = this.userService.getUser(q.userId).subscribe(({name, lastName}) => { userSub.unsubscribe(); q.userName = `${name} ${lastName}` });
      });

      let sub =  this.productionOrderService.getProductionOrder(productionOrder.id).subscribe(([productionOrder]) => {
        sub.unsubscribe();
        this.odp = productionOrder;
        this.odpSectionSelect = productionOrder.sections.map(({name}) => ({value: name, name}) );
        let valid = productionOrder.sections.map(({name}) => name).includes(qualityCertificate.odpSection);
        if(valid) this.remission.qualityCertificate['section'] = productionOrder.sections.find(({name}) => name == qualityCertificate.odpSection);
        this.form.get('odpSection').patchValue(valid ? qualityCertificate.odpSection : this.odpSectionSelect[0].value);
      });

      let defSub = this.defectService.getDefects().subscribe(defects => {
        defSub.unsubscribe();
        let appliesCustomer = defects.some(({customerObj={}}) => customerObj.id == customerRef.id);
        let aqls = {};
        this.defectsInit ={'data': defects.reduce((acc, cur) => {
          let defHasCustomer = !!cur.customerObj;
          let defApplies = defHasCustomer && cur.customerObj.id == customerRef.id;
          if(defApplies == appliesCustomer && defApplies == defHasCustomer){
            this.defectsDB[cur.description] = <any>cur;
            aqls[cur.group] = cur.AQL;
            acc[cur.description] = null;
          }
          return acc;
        }, {}) };
        this.AQLS = Object.keys(aqls).map(group => {
          let s = `${group} ${aqls[group]}`;
          this.aqls[s] = 0;
          return s;
        });
        if(qualityCertificate.aqls) this.aqls = qualityCertificate.aqls;
      });
    });
  }
  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  createForm(){
    this.form = this.fb.group({
      status: 'key1',
      evalGuide: '',
      sampleAmount: '',
      odpSection: '',
      notes: '',
      inspection: 'key1',
      inspectionLevel: this.inspectionLevels[0],
    });
  }

  get qualityCertificate(): QualityCertificate {
    return {
      lotIsComplete: this.lotIsComplete,
      defects: this.defects,
      aqls: this.aqls,
      ...this.form.value
    }
  }

  onSubmit({ value, valid }: { value: any, valid: any }){
    this.service.updateByField({qualityCertificate: this.qualityCertificate}, this.remissionId);
    toast('Datos guardados.', 3000);
  }

  onPrint(){
    if(this.qualityCertificate.status != 'key2') return toast('El certificado de calidad no está aprobado.', 2000);
    this.qualitys.push({
      ...this.qualityCertificate,
      date: new Date(),
      userId: this.authService.currentUser.id
    });
    this.service.updateByField({qualityHistory: this.qualitys, qualityCertificate: this.qualityCertificate}, this.remissionId);
    window['sendQualityCertificate'](false);
    //toast('Añadido al registro.', 5000)
  }

  //////////////////////////////////////////////////////////////////////////////////////////////DEFECTS
  defect: Defect = {} as Defect;
  defects: Defect[] = [];
  defectsDB: {[name: string]: DefectId} = {};
  get defectSum(){ return this.defects.reduce((acc, cur) => { acc[cur.aql] = (acc[cur.aql] || 0) + cur.quantity; return acc }, {}) }
  modalActionsDefect = new EventEmitter<string|MaterializeAction>();
  modalParamsDefect = [{dismissible: true}];
  get defectIsValid(){
    const { description, quantity } = this.defect;
    //list of validators
    return !(
      !description ||
      !quantity ||
      quantity <= 0 
    )
  }
  
  indexDefect: number;
  openModalDefect(index?: number) {
    this.indexDefect = index;
    this.defect = index != undefined ? {aql: this.AQLS[0], ...this.defects[this.indexDefect], } : {aql: this.AQLS[0]} as Defect;
    this.modalActionsDefect.emit({ action: 'modal', params: ['open'] });
  }
  closeModalDefect() {
    this.modalActionsDefect.emit({ action: 'modal', params: ['close'] });
  }
  
  touchDefect(){
    if(this.indexDefect == undefined) this.defects.push({...this.defect});
    else this.defects[this.indexDefect] = {...this.defect};
    this.closeModalDefect();
  }
  removeDefect(index) {
    this.defects.splice(index,1);
  }

  onDefectChange(){
    let {group, AQL} = this.defectsDB[this.defect.description];
    this.defect.aql = `${group} ${AQL}`;
  }
  //////////////////////////////////////////////////////////////////////////////////////////////DEFECTS

  formatDate(date: Date){
    var dd:string = date.getDate() + '';
    var mm:string = date.getMonth()+ 1 + '';
    var yyyy = date.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    let time = [ date.getHours(), date.getMinutes(), date.getSeconds() ];
    return `${dd}/${mm}/${yyyy} ${time.join(':')}`;
  } 

  inspectionTypeSelector(){
    let input = this.form.get('inspection')
    return String(this.data.inspectionTypes[input.value].name)
  }
  
  get pdfJson(){
    return this.remission ? JSON.stringify({
      customerName: (this.remission as any).customerObj.name,
      fiscalDataName: (this.remission as any).fiscalDataObj.businessName,
      productionOrderFolio: this.remission.productionOrder.folio,
      productionOrderQuantity: this.remission.productionOrder.quantity,
      //generalActivities: this.odp.generalActivities,
      //sections: this.odp.sections,
      ...this.remission.productionOrder,
      folio: this.remission.folio,
      date: this.remission.date,
      quantity: this.remission.quantity,
      description: this.remission.description,
      boxs: this.remission.boxs,
      qualityCertificate: {user: this.authService.currentUser.fullName, ...this.remission.qualityCertificate},
      inspectionType: this.inspectionTypeSelector(),
      inspectionLevel: this.form.get('inspectionLevel').value || '',
      companyImgUrl: this.company.imageURL,
      companyName: this.company.name,
      companyWebPage: this.company.webPage || '',

      isoDescriptionRem: this.isoDescription.rem,
      isoDescriptionEtiq: this.isoDescription.etiq,
      isoDescriptionCrtCal: this.isoDescription.crtcal,

      qualityInspector: this.qualityInspectorName

    }) : '';
  }

}
